// const CMDeleteModal = ({ message }) => {
//   <Dialog open={confirmDeleteOpen} onClose={() => setConfirmDeleteOpen(false)}>
//     <DialogTitle>Confirm Delete</DialogTitle>
//     <DialogContent>
//       <DialogContentText>
//         {message}
//       </DialogContentText>
//     </DialogContent>
//     <DialogActions>
//       <Button onClick={() => setConfirmDeleteOpen(false)} color="primary">
//         Cancel
//       </Button>
//       <Button
//         onClick={() => handleDelete(deleteScenarioUuid)}
//         color="secondary"
//       >
//         Confirm
//       </Button>
//     </DialogActions>
//   </Dialog>;
// };

// export default CMDeleteModal;

import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@material-ui/core";

const CMDeleteModal = ({ open, message, onCancel, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CMDeleteModal;
